import styles from './TerminalCard.module.css';

type TerminalCardProps = {
  label: string;
  code?: string | null;
  cityState?: string | null;
};

const EMPTY_TERMINAL_CODE = '-';

export const TerminalCard = ({ label, code, cityState }: TerminalCardProps) => (
  <div className={styles.card} data-testid='terminal-card'>
    <span className={styles.label}>{label}</span>
    <span className={styles.code}>{code ?? EMPTY_TERMINAL_CODE}</span>
    {cityState && <span className={styles.cityState}>{cityState}</span>}
  </div>
);
